import { render, staticRenderFns } from "./skgl.vue?vue&type=template&id=5e7cff67&scoped=true&"
import script from "./skgl.vue?vue&type=script&lang=js&"
export * from "./skgl.vue?vue&type=script&lang=js&"
import style0 from "./skgl.vue?vue&type=style&index=0&id=5e7cff67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7cff67",
  null
  
)

export default component.exports